export const apiPrefix = {
    companies: "/companies",
};
